module.exports = __webpack_public_path__ + "static/media/homeColorwheel.2dc03d70.png";